<template>
    <div>
      <div id="threesceneeee" :style="background"></div>
      <div class="title-logo">
        数知了仓储环境监测3D可视化系统
      </div>
  
      <div class="drop-down">
        <div class="select">选择楼层</div>
        <div class="floor">
          <div class="item" @click="goonefloor">一层</div>
          <div class="item" @click="gotwofloor">二层</div>
          <div class="item" @click="gothreefloor">三层</div>
          <div class="item" @click="gofourfloor">四层</div>
          <div class="item" @click="gofivefloor">五层</div>
        </div>
      </div>
  
      <div class="contone">
        <div class="current">
          <span>当前：辅料仓库 一 层</span>
        </div>
        <!-- <div>
          <span class="biaoti">环境温湿度</span>
          <i-Switch @on-change="hjwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
        <div>
          <span class="biaoti">包芯温湿度</span>
          <i-Switch @on-change="bxwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
        <div>
          <span class="biaoti">虫情</span>
          <i-Switch @on-change="bxwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div>
        <div>
          <span class="biaoti">烟垛信息</span>
          <i-Switch @on-change="bxwsd" size="large">
            <span slot="open"></span>
            <span slot="close"></span>
          </i-Switch>
        </div> -->
      </div>
      <!-- <div class="sidebar">
        侧边栏
      </div> -->
    </div>
  </template>
  
  <script>
  import * as THREE from "three";
  import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
  import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
  import {
    getScene,
    getAxesHelper,
    createPoint,
    createAmbient,
    createGround,
    createCamera,
    createWebGLRenderer,
    createWallMaterail,
    createWallObject,
    createResultBsp,
    createWindow,
    createDoor,
    createPillar,
    createSmokecrib,
    createSub,
    createElevator,
    createRaycaster,
    cteateVector2,
  } from "../js/threejs.js";
  export default {
    name: "OneFloor",
    data() {
      return {
        scene: null,
        camera: null,
        renderer: null,
        width: 0,
        height: 0,
        matArrayB: [],
        raycaster: null,
        mouse: null,
        ambienthumiture: [], //环境温湿度铭牌集合
        corehumiture: [], //包芯温湿度铭牌集合
        background:{
          backgroundImage: "url('../img/icons/bcImg.png')",
                          backgroundRepeat: "no-repeat",
                          position: "fixed",
                          backgroundSize: "100% 100%",
        },
        datahm:[{'mac':'123',data:['20℃','30%']}],
        group:new THREE.Group()
      };
    },
    mounted() {
      //
      this.init();
      window.addEventListener("click", this.onmodelclick, true);
    },
    methods: {
      init() {
        // 初始化画布宽高
        this.scene = getScene();
        this.raycaster = createRaycaster();
        this.mouse = cteateVector2();
        ///初始化
        //loadinit();
        /**
         * 辅助坐标系  参数1000表示坐标系大小
         */
        //var axisHelper = getAxesHelper(1000);
        //this.scene.add(axisHelper);
        //点光源
        var point = createPoint(0x444444, 1000, 500, 0);
        this.scene.add(point); //点光源添加到场景中
        //环境光
        var ambient = createAmbient(0xcccccc);
        this.scene.add(ambient);
        //创建一个地面网格
        var ground = createGround(
          "../img/icons/shuinidi.png",
          2000,
          1000,
          this.resetRender
        );
        this.scene.add(ground);
        /**
         * 相机设置
         */
        var width = window.innerWidth; //窗口宽度
        var height = window.innerHeight; //窗口高度
        var k = width / height; //窗口宽高比
        var s = 100000; //三维场景显示范围控制系数，系数越大，显示的范围越大
        //创建相机对象
        // var camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 1000);
        this.camera = createCamera(60, k, 0.1, 100000); //0.1, 100000场景渲染开始位置，最远能看到哪里
        this.camera.position.set(0, 1000, -1000); //设置相机位置
        this.camera.lookAt(this.scene.position); //设置相机方向(指向的场景对象)position
        /**
         * 创建渲染器对象
         */
        this.renderer = createWebGLRenderer();
        this.renderer.setSize(width, height); //设置渲染区域尺寸
        //this.renderer.setClearColor(0xb9d3ff, 1); //设置背景颜色
        document.getElementById("threesceneeee").appendChild(this.renderer.domElement); //body元素中插入canvas对象
        new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
        this.resetRender();
        //监听鼠标、键盘事件
        var controls = new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
        controls.addEventListener("change", () => {
          this.resetRender();
        });
        ///以下为添加具体的模型//////////////////////////////////////////////////////////////////////////////////////////
        //加载墙的材质
        this.matArrayB = createWallMaterail();
  
  
        ///添加墙（南）
        var wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 50, 0);
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 50, 0);
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, 500);
        this.scene.add(wall);
        wall = createWallObject(5, 100, 300, 1.5, this.matArrayB, -850, 50, 400);
        this.scene.add(wall);
        wall = createWallObject(5, 100, 100, 1, this.matArrayB, -700, 50, 450);
        this.scene.add(wall);
        
        ///创建挖空的墙
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, -500, "墙面");
        var door_cube1 = createWallObject(180, 90, 100, 0, this.matArrayB, 0, 45, -500, "前门1");
        var door_cube2 = createWallObject(100, 90, 100, 0, this.matArrayB, 280, 45, -500, "前门1");
        var door_cube3 = createWallObject(100, 90, 100, 0, this.matArrayB, 650, 45, -500, "前门1");
        var door_cube4 = createWallObject(100, 90, 100, 0, this.matArrayB, -280, 45, -500, "前门1");
        var door_cube5 = createWallObject(100, 90, 100, 0, this.matArrayB, -460, 45, -500, "前门1");
        var door_cube6 = createWallObject(100, 90, 100, 0, this.matArrayB, -730, 45, -500, "前门1");
        var door_cube7 = createWallObject(100, 90, 100, 0, this.matArrayB, -880, 45, -500, "前门1");
        var door_cube8 = createWallObject(100, 90, 100, 0, this.matArrayB, 460, 45, -500, "前门1");
  
        // var window_cube1 = createWallObject(120, 90, 5, 0, this.matArrayB, -400, 45, -500, "窗户1");
        // var window_cube2 = createWallObject(120, 90, 5, 0, this.matArrayB, 400, 45, -500, "窗户2" );
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        objects_cube.push(door_cube3);
        objects_cube.push(door_cube4);
        objects_cube.push(door_cube5);
        objects_cube.push(door_cube6);
        objects_cube.push(door_cube7);
        objects_cube.push(door_cube8);
        // objects_cube.push(window_cube1);
        // objects_cube.push(window_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
  
        //安装门
        // var window_cube = createWindow(
        //   120,
        //   90,
        //   2,
        //   0,
        //   -400,
        //   45,
        //   -500,
        //   "安装窗户",
        //   this.resetRender
        // );
        // this.scene.add(window_cube);
        // window_cube = createWindow(
        //   120,
        //   90,
        //   2,
        //   0,
        //   400,
        //   45,
        //   -500,
        //   "安装窗户",
        //   this.resetRender
        // );
        // this.scene.add(window_cube);
  
        //安装门
        var door_cube = createDoor(100, 90, 2, 0, -880, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createDoor(100, 90, 2, 0, -730, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createDoor(100, 90, 2, 0, -460, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createElevator(100, 90, 2, 0, -280, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createElevator(100, 90, 2, 0, 280, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createDoor(100, 90, 2, 0, 460, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createDoor(100, 90, 2, 0, 650, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
  
  
  
  
        ///创建挖空的墙
        wall = createWallObject(5, 100, 1200, 0.5, this.matArrayB, 0, 50, -180, "墙面");
        var door_cube1 = createWallObject(150, 90, 5, 0, this.matArrayB, 0, 45, -180, "前门1");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装门
        var door_cube = createDoor(150, 90, 2, 0, 0, 45, -180, "安装门", this.resetRender);
        this.scene.add(door_cube);
  
  
        
        ///创建挖空的墙
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 600, 50, 0, "墙面");
        var door_cube1 = createWallObject(5, 90, 100, 0, this.matArrayB, 600, 45, -60, "前门1");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装门
        var door_cube = createDoor(100, 90, 2, 0.5, 600, 45, -60, "安装门", this.resetRender);
        this.scene.add(door_cube);
  
  
  
        ///创建挖空的墙
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 700, 50, 0, "墙面");
        var door_cube1 = createWallObject(5, 90, 100, 0, this.matArrayB, 700, 45, -60, "前门1");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装门
        var door_cube = createDoor(100, 90, 2, 0.5, 700, 45, -60, "安装门", this.resetRender);
        this.scene.add(door_cube);
  
  
  
        ///创建挖空的墙
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, -600, 50, 0, "墙面");
        var door_cube1 = createWallObject(5, 90, 100, 0, this.matArrayB, -600, 45, -60, "前门1");
        var door_cube2 = createWallObject(5, 90, 100, 0, this.matArrayB, -600, 45, 200, "前门1");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装门
        var door_cube = createDoor(100, 90, 2, 0.5, -600, 45, -60, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createDoor(100, 90, 2, 0.5, -600, 45, 200, "安装门", this.resetRender);
        this.scene.add(door_cube);
  
  
  
        //添加柱子（南）
        var pillar = createPillar(40, 100, 40, -700, 50, 350, '柱子A1');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -500, 50, 350, '柱子A2');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -300, 50, 350, '柱子A3');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -100, 50, 350, '柱子A4');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 100, 50, 350, '柱子A5');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 300, 50, 350, '柱子A6');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 500, 50, 350, '柱子A7');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 700, 50, 350, '柱子A8');
        this.scene.add(pillar);
  
        pillar = createPillar(40, 100, 40, -700, 50, 60, '柱子B1');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -500, 50, 60, '柱子B2');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -300, 50, 60, '柱子B3');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -100, 50, 60, '柱子B4');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 100, 50, 60, '柱子B5');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 300, 50, 60, '柱子B6');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 500, 50, 60, '柱子B7');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 700, 50, 60, '柱子B8');
        this.scene.add(pillar);
  
        pillar = createPillar(40, 100, 40, -700, 50, -180, '柱子C1');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -500, 50, -180, '柱子C2');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -300, 50, -180, '柱子C3');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, -100, 50, -180, '柱子C4');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 100, 50, -180, '柱子C5');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 300, 50, -180, '柱子C6');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 500, 50, -180, '柱子C7');
        this.scene.add(pillar);
        pillar = createPillar(40, 100, 40, 700, 50, -180, '柱子C8');
        this.scene.add(pillar);
        
        
        
  
        ///添加烟垛（南）
        // var smokecrib = createSub(120, 100, 240, -800, 50, 280, this.resetRender,'烟垛A1');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 240, -600, 50, 280, this.resetRender,'烟垛A2');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 240, -400, 50, 280, this.resetRender,'烟垛A3');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 240, -200, 50, 280, this.resetRender,'烟垛A4');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 240, 0, 50, 280, this.resetRender,'烟垛A5');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 240, 200,  50, 280, this.resetRender,'烟垛A6');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 240, 400,  50, 280, this.resetRender,'烟垛A7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 240, 600, 50, 280, this.resetRender,'烟垛A8');
        // this.scene.add(smokecrib);
  
        // smokecrib = createSub(120, 100, 180, -800, 50, -320, this.resetRender,'烟垛B1');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 180, -600, 50, -320, this.resetRender,'烟垛B2');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 180, -400, 50, -320, this.resetRender,'烟垛B3');
        // this.scene.add(smokecrib);
        // smokecrib = createSub(120, 100, 180, 400, 50, -320, this.resetRender,'烟垛B6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(120, 100, 180, 600, 50, -320, this.resetRender,'烟垛B7');
        // this.scene.add(smokecrib);
       
  
  
  
        // var smokecrib = createSmokecrib(240, 100, 160, 300, 40, 300, this.resetRender,'烟垛1');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 0, 40, 300, this.resetRender,'烟垛2');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, -300, 40, 300, this.resetRender,'烟垛3');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 300, 40, 0, this.resetRender,'烟垛4');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 0, 40, 0, this.resetRender,'烟垛5');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, -300, 40, 0, this.resetRender,'烟垛6');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 300,  40, -300, this.resetRender,'烟垛7');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, 0, 40, -300, this.resetRender,'烟垛8');
        // this.scene.add(smokecrib);
        // smokecrib = createSmokecrib(160, 80, 100, -300, 40, -300, this.resetRender,'烟垛9');
        // this.scene.add(smokecrib);
  
  
  
        //加载外部模型---包芯温湿度（南）
        // this.createFBX('../img/baoxin.fbx',-720, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-520, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-320, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-120, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',80, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',280, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',480, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',680, 50, 280, 0, 0, 1.5, 1, 1, 1,'123');
  
        // this.createFBX('../img/baoxin.fbx',-720, 50, -320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-520, 50, -320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',-320, 50, -320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',480, 50, -320, 0, 0, 1.5, 1, 1, 1,'123');
        // this.createFBX('../img/baoxin.fbx',680, 50, -320, 0, 0, 1.5, 1, 1, 1,'123');
  
  
  
        //加载外部模型---环境温湿度（南）
        // this.createFBX('../img/huanjing.fbx',-600, 70, 120, 0, 1.56, 0, 0.5, 0.5, 0.5);
        this.createFBX('../img/icons/huanjing.fbx',-700, 70, 40, 0, 1.56, 3.12, 0.5, 0.5, 0.5);
        this.createFBX('../img/icons/huanjing.fbx',-300, 70, 40, 0, 1.56, 3.12, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',600, 70, 120, 0, 1.56, 0, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',-600, 70, -130, 0, 1.56, 0, 0.5, 0.5, 0.5);
        this.createFBX('../img/icons/huanjing.fbx',100, 70, 40, 0, 1.56, 3.12, 0.5, 0.5, 0.5);
        this.createFBX('../img/icons/huanjing.fbx',500, 70, 40, 0, 1.56, 3.12, 0.5, 0.5, 0.5);
        // this.createFBX('../img/huanjing.fbx',600, 70, -130, 0, 1.56, 0, 0.5, 0.5, 0.5);
  
        
      },
      ///加载模型显示
      resetRender(obj) {
        //console.log(obj);
        this.renderer.render(this.scene, this.camera);
      },
      ///加载外部模型
    ///path 模型地址
    ///posx 模型在x轴上的位置
    ///posy 模型在y轴上的位置
    ///posz 模型在z轴上的位置
     ///rotx 模型在x轴上旋转角度
    ///roty 模型在y轴上旋转角度
    ///rotz 模型在z轴上旋转角度
    ///zoomx 模型在x轴上缩放比例
    ///zoomy 模型在y轴上缩放比例
    ///zoomz 模型在z轴上缩放比例
    createFBX(path,posx,posy,posz,rotx,roty,rotz,zoomx,zoomy,zoomz,name) {
      const loader = new FBXLoader();
      let _this=this;
      loader.load(path, function (obj) {
        //obj.scale.x = obj.scale.y = obj.scale.z = 100;
        //obj.rotation.y = 500;
        obj.rotation.y =rotx;
          obj.rotation.x = roty;
          obj.rotation.z = rotz;//模型的角度
        //let mesh = obj;
        obj.position.x = posx;//模型所在位置
        obj.position.y = posy;//模型所在位置
        obj.position.z = posz;//模型所在位置
        obj.scale.set(zoomx, zoomy, zoomz);//模型缩放比例
        obj.name=name;
        _this.group.add(obj);
        _this.scene.add(_this.group);
        _this.resetRender('外部模型');
      });
    },
       
      ///点击事件
      onmodelclick(event) {
        console.log(1111111111111111111111111111111111111111111111111111111111111111);
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
  
        // 计算物体和射线的焦点
        var intersects = this.raycaster.intersectObjects(this.scene.children);
       
  
        var ress = intersects.filter(function (res) {
          return res && res.object;
        });
        
  
        //点击事件
        var res = intersects.filter(function (res) {
          return res && res.object;
        })[0];
        if (res && res.object) {
          //console.log(res)
          var selectObject = res.object;
          //alert(selectObject.name)
          if (selectObject.name == "123456") {
            //$(".contone").show();
          } else {
            //$(".contone").hide();
          }
         // console.log(selectObject.name);
  
          //window.location.href = "test111.html";
        }
      },

      goonefloor(){
        window.removeEventListener('click',  this.onmodelclick, false)//去除上一层级的点击事件
        this.$router.replace('/fuliao/onefloor')
      },

      gotwofloor(){
        window.removeEventListener('click',  this.onmodelclick, false)//去除上一层级的点击事件
        this.$router.replace('/fuliao/twofloor')
      },

      gothreefloor(){
        window.removeEventListener('click',  this.onmodelclick, false)//去除上一层级的点击事件
        this.$router.replace('/fuliao/threefloor')
      },

      gofourfloor(){
        window.removeEventListener('click',  this.onmodelclick, false)//去除上一层级的点击事件
        this.$router.replace('/fuliao/fourfloor')
      },

      gofivefloor(){
        window.removeEventListener('click',  this.onmodelclick, false)//去除上一层级的点击事件
        this.$router.replace('/fuliao/fivefloor')
      },


      //环境温湿度显示
      hjwsd(event) {
        //console.log(this.ambienthumiture);
        this.ambienthumiture.forEach((wall, index) => {
          if (event) {
            wall.visible = true;
          } else {
            wall.visible = false;
          }
        });
        this.resetRender();
      },
      //环境温湿度显示
      bxwsd(event) {
        //console.log(this.ambienthumiture);
        this.corehumiture.forEach((wall, index) => {
          if (event) {
            wall.visible = true;
          } else {
            wall.visible = false;
          }
        });
        this.resetRender();
      },
    },
  };
  </script>
  
  <style scoped>
    #threescene{
      width: 100%;
      height: 100%;
  
    }
    .title-logo {
    position: fixed;
    width: 100%;
    height: 80px;
    color: #00ffff;
    font-family: none;
    font-size: 24px;
    font-weight: bold;
    line-height: 70px;
    background-image: url(../../../../public/img/icons/header_logo-1.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    margin: 0 auto;
    text-align: center;
  }
  
  /* 选择楼层 */
  .select {
  position: absolute;
  top: 100px;
  left: 40px;
  padding: 10px 15px;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  border: 0;
  outline: none;
  background-color: rgba(0, 255, 255, 0.6);
  appearance:none;   
  -moz-appearance:none;   
  -webkit-appearance:none;
  text-align: center;  
  cursor: pointer; 
  }

  .floor {
    position: absolute;
    top: 150px;
    left: 40px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    padding: 10px 15px;
    line-height: 40px;
    background-color: rgba(0, 255, 255, 0.2);
    cursor: pointer;
    display: none;
  }

  .drop-down:hover .floor {
    display: block;
  }

  .item {
    width: 80px;
  }

  .item:hover {
    color: #00ffff;
    background-color: rgba(0, 255, 255, 0.2);
    border-radius: 4px;
  }
  
  /* 当前楼层 */
  .contone {
    /* width: 200px;
    height: 200px; */
    z-index: 99999;
    position: absolute;
    top: 100px;
    left: 180px;
    text-align: left;
    /* border: #fff 1px solid; */
    padding: 10px 15px;
    box-shadow: 0 0 2px #00ffff inset;
    background: linear-gradient(#00ffff, #00ffff) left top, linear-gradient(#00ffff, #00ffff) left top, linear-gradient(#00ffff, #00ffff) right bottom, linear-gradient(#00ffff, #00ffff) right bottom;
    background-repeat: no-repeat;
    background-size: 1px 10px, 10px 1px;
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .current {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
  }
  
  
  </style>